import { render, staticRenderFns } from "./PDMultiObj.vue?vue&type=template&id=5ad1c802&scoped=true"
import script from "./PDMultiObj.vue?vue&type=script&lang=js"
export * from "./PDMultiObj.vue?vue&type=script&lang=js"
import style0 from "./PDMultiObj.vue?vue&type=style&index=0&id=5ad1c802&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad1c802",
  null
  
)

export default component.exports